module.exports = __webpack_public_path__ + "static/media/cf-logo-blanco.b97b22d7.png";